import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import './login.css';
import loginImage from "../static/login-image.png";
import { Form, Input, Button, Icon, Alert, Row, Col, message, Modal } from 'antd';
import Translate from "../translate/Translate";

import {
	userLogin
} from '../../modules/user';


class Login extends Component {
	constructor(props) {
		super(props);
		console.log(window.location.href)
		var str = ""
		const words = window.location.href.split('class=')
		if (words.length > 1) {
			str = words[1]
		}
		this.state = {
			loading: false,
			currentLang: 2,
			language: [["eng", "EN", "inline"], ["simp", "简", "inline"], ["trad", "繁", "none"]],
			errormessage: null,
			className: str
		}
	}

	componentDidMount() {
		document.getElementById("classCode").value = this.state.className
	}

	formRef = React.createRef();

	handleSubmit = e => {
		// this.setState({ loading: true });
		e.classCode = document.getElementById("classCode").value
		console.log(e);

		var classNameString = e.studentCode.substr(7, 2)
		var classNumberString = e.studentCode.substr(9, 2)

		if (e.studentCode.length > 12) {
			classNameString = e.studentCode.substr(9, 2)
			classNumberString = e.studentCode.substr(11, 2)
		}

		this.props.userLogin(e).then(
			(res) => {
				if (res) {
					this.setState({ loading: false, errormessage: null });

					if (this.props.language === "tc") {
						Modal.confirm({
							title: '提示',
							content: '每個帳號只可以做一次，你確定你是' + classNameString + ' ' + classNumberString + ' 本人嗎? ',
							zIndex: 2000,
							cancelText: '不是',
							onCancel: () => {
								localStorage.clear()
								this.props.history.push('/login');
							},
							okText: '是',
							onOk: () => {
								this.props.history.push('/questions');
							},
						});
					} else if (this.props.language === "sc") {
						Modal.confirm({
							title: '提示',
							content: '每个帐号只可以做一次，你确定你是' + classNameString + ' ' + classNumberString + ' 本人吗? ',
							zIndex: 2000,
							cancelText: '不是',
							onCancel: () => {
								localStorage.clear()
								this.props.history.push('/login');
							},
							okText: '是',
							onOk: () => {
								this.props.history.push('/questions');
							},
						});
					} else {
						Modal.confirm({
							title: 'Reminder',
							content: 'Each account can only be done once, are you sure you are ' + classNameString + ' ' + classNumberString + ' ? ',
							zIndex: 2000,
							cancelText: 'No',
							onCancel: () => {
								localStorage.clear()
								this.props.history.push('/login');
							},
							okText: 'Yes',
							onOk: () => {
								this.props.history.push('/questions');
							},
						});
					}

				} else {
					this.setState({ loading: false, errormessage: "Please check Username/Password and try again." });
				}
			},
			(err) => {
				// console.log("error")
				this.setState({ loading: false, errormessage: "Please check Username/Password and try again." });
				// this.formRef.current.resetFields();
			}
		)

	}



	render() {

		const { loading, errormessage } = this.state;

		return (
			<div className="loginContainer">
				<div className="loginBlock">
					<div className="loginImageContainer">
						<img src={loginImage} className="loginImage"></img>
					</div>
					<div className="loginFormContainer">
						<div>
							<div className="loginTitle">SDS <Translate id="main.title" /></div>
							<Form ref={this.formRef} onFinish={this.handleSubmit} className="loginForm">
								{(errormessage) ? <Alert message={errormessage} type="error" style={{ marginBottom: '20px' }} showIcon /> : ""}
								<div className="inputTitle"><Translate id="login.classid" /></div>
								<Form.Item name="classCode" >
									<Input className="loginInput" />
								</Form.Item>
								<div className="inputTitle"><Translate id="login.studentid" /></div>
								<Form.Item name="studentCode"
									rules={[
										{
											required: true,
											message: "Field is required!"
										},
									]}>
									<Input className="loginInput" />
								</Form.Item>
								<div className="inputTitle"><Translate id="login.pw" /></div>
								<Form.Item name="password"
									rules={[
										{
											required: true,
											message: "Field is required!"
										},
									]}>
									<Input type="password" className="loginInput" />
								</Form.Item>

								<Form.Item className="loginBtnContainer">
									<Button type="primary" htmlType="submit" className="loginsubmitBtn"><Translate id="login.login" /></Button>
								</Form.Item>
							</Form>
							<div>
								<p>
									<Translate id="login.privacy1" />
								</p>
								<p>
									<Translate id="login.privacy2" />
								</p>
								<p>
									<Translate id="login.privacy3" />
								</p>
								<p>
									<Translate id="login.privacy4" />
								</p>
							</div>
						</div>


					</div>
				</div>
			</div>
		);
	}
}


const mapStateToProps = state => ({
	userAuthenticated: state.user.userAuthenticated,
	language: state.mainpage.language
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			userLogin
		},
		dispatch
	);

//mapStateToProps should be passed as the 1st argument to connect
export default connect(mapStateToProps, mapDispatchToProps)(Login);